import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle, faUser, faCalendarCheck } from '@fortawesome/pro-solid-svg-icons';
import {
  faInfo,
  faTimes,
  faCaretDown,
  faCaretUp,
} from '@fortawesome/free-solid-svg-icons';

library.add(faExclamationTriangle);
library.add(faUser);
library.add(faInfo);
library.add(faTimes);
library.add(faCalendarCheck);
library.add(faCaretUp);
library.add(faCaretDown);
